import { useState, useEffect, useMemo, useRef } from "react";

import Pagination from "controls/Pagination";
import CartItem from "./CartItem";
import CartDelivery from "./CartDelivery";
import CartPayment from "./CartPayment";
import CartTotal from "./CartTotal";
import CartPreview from "./CartPreview";
import CartService from "api/precision/CartService";
import ConfirmModal from "controls/ConfirmModal";
import ConfirmToast from "controls/ConfirmToast";
import { money } from "common/functions"
import 'styles/scora.css';

/**
 * Cart Item - {
 *   "id": res.data.data,
 *   "user_id": props.user.id,
 *   "product_id": props.product.id,
 *   "product_name": props.product.name,
 *   "quantity": preorderInfo.quantity
 * }
 */
export default function Cart(props) {
  document.title = 'Shopping Cart';

  const placeOrderBtn = useRef(null);
  const { emptyCart, setQuantity, cartItems, removeFromCart } = props.useShoppingCart();
  const { getProfile } = props.useSession();
  const { navigate, location } = props.useRouter();
  const [user] = useState(getProfile());

  // cart, delivery, payment, preview
  const hash = location.hash !== "" ? location.hash.substring(1) : "cart";
  const [confirmation, setConfirmation] = useState({});
  const [toastMessage, setToastMessage] = useState({});

  const [rowPerPage, setRowPerPage] = useState(5);
  const [pageNumber, setPageNumber] = useState(0);

  useEffect(() => {
    if (cartItems.length > 0) {
      cartItems.map((item, idx) => {
        if (item.product == "blackSticker") {
          drawBlackSticker(idx, item.canoeNumber);
        }
        else {
          drawWhiteSticker(idx, item.canoeNumber);
        }
      })
    }
  }, []);

  const drawWhiteSticker = (idx, number) => {
    const el = document.getElementById("canvasItem" + idx);
    const ctx = el.getContext('2d');

    ctx.textAlign = "center";
    ctx.font = "20px Arsenal";
    let canvas = ctx.canvas;
    let centerX = canvas.width / 2;
    let centerY = canvas.height / 2;
    let radius = Math.min(canvas.width, canvas.height) / 2 - 2;

    // Clear previous drawing
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Draw white circle background
    ctx.beginPath();
    ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI, false);
    ctx.fillStyle = "#FFFFFF";
    ctx.fill();
    ctx.closePath();

    // Draw border
    ctx.beginPath();
    ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI, false);
    ctx.lineWidth = 2; // Adjust border thickness as needed
    ctx.strokeStyle = "#000000"; // Black border
    ctx.stroke();
    ctx.closePath();

    // Dynamically scale font size to fit the circle
    let fontSize = radius * 1.2; // Start with a large font size
    ctx.font = `bold ${fontSize}px NewOrderBold`;
    let textWidth = ctx.measureText(number).width;

    // Reduce font size until text fits within 80% of the circle's diameter
    while (textWidth > radius * 1.8 && fontSize > 10) {
      fontSize -= 2;
      ctx.font = `bold ${fontSize}px NewOrderBold`;
      textWidth = ctx.measureText(number).width;
    }

    // Draw the canoe number at the center
    ctx.textBaseline = "middle"; // Center the text vertically
    ctx.fillStyle = "#000000"; // Black text
    ctx.fillText(number, centerX, centerY + 2); // Adjust vertical position as needed

  }

  const drawBlackSticker = (idx, number) => {
    const el = document.getElementById("canvasItem" + idx);
    const ctx = el.getContext('2d');

    ctx.textAlign = "center";
    ctx.font = "20px Arsenal";
    let canvas = ctx.canvas;

    let centerX = canvas.width / 2;
    let centerY = canvas.height / 2;
    let radius = Math.min(canvas.width, canvas.height) / 2;

    // Clear previous drawing
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Draw white circle background
    ctx.beginPath();
    ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI, false);
    ctx.fillStyle = "#000000";
    ctx.fill();
    ctx.closePath();

    // Dynamically scale font size to fit the circle
    let fontSize = radius * 1.2; // Start with a large font size
    ctx.font = `bold ${fontSize}px NewOrderBold`;
    let textWidth = ctx.measureText(number).width;

    // Reduce font size until text fits within 90% of the circle's diameter
    while (textWidth > radius * 1.8 && fontSize > 10) {
      fontSize -= 2;
      ctx.font = `bold ${fontSize}px NewOrderBold`;
      textWidth = ctx.measureText(number).width;
    }

    ctx.textBaseline = "middle"; // Center the text vertically
    ctx.fillStyle = "#FFFFFF"; // Black text
    ctx.fillText(number, centerX, centerY + 2); // Adjust vertical position as needed

  }

  const getUnitPrice = (qnty) => {
    switch (parseInt(qnty)) {
      case 4: case 5: case 6: case 7:
        return 57.28;
      case 8: case 9: case 10: case 11:
        return 30.52;
      case 12: case 13: case 14: case 15:
        return 21.60;
      case 16: case 17: case 18: case 19:
        return 17.14;
      case 20: case 21: case 22: case 23:
        return 14.46;
      case 24: case 25: case 26: case 27:
        return 12.17;
      case 28: case 29: case 30: case 31:
        return 10.96;
      case 32: 
        return 10.96;
      default:
        return 10.96;
    }
  }

  const placeOrder = (ev) => {
    ev.stopPropagation();
    placeOrderBtn.current.disabled = true;
    // Place order now

    // placeOrderBtn.current.disabled = false;
  }

  const paginate = (type, pageId) => {
    setPageNumber(pageId);
  }

  const cartHeader = useMemo(() => {
    let cartTitle = "Shopping cart";
    if (hash == "preview") {
      cartTitle = "Order preview";
    }
    else if (hash == "delivery") {
      cartTitle = "Delivery information";
    }
    else if (hash == "payment") {
      cartTitle = "Payment information";
    }
    else if (hash == "preview") {
      cartTitle = "Order preview";
    }

    return <section className="d-flex justify-content-between align-items-center p-3 bg-secondary-subtle shadow">
      <h1 className="ps-5" style={{ fontSize: "35px" }}>{cartTitle}</h1>
    </section>
  });

  const cartSubTotal = useMemo(() => {
    let subTotal = 0.0;
    cartItems.map((item) => {
      subTotal = subTotal + (item.quantity * getUnitPrice(item.quantity));
    });
    return subTotal.toFixed(2);
  });

  const handleQntyChange = (itemId, qnty) => {
    setQuantity(itemId, qnty)
  }

  return (
    <div className="">
      
      <section className="hero_section">
        <div className="mx-md-auto">
          <h1 style={{ width: '875px' }}>Cart</h1>
        </div>
      </section>

      <div className="px-3" style={{ width: '100vw' }}>
        <section className="d-flex flex-column mt-5 mb-4 mx-auto" style={{ backgroundColor: '#f6f5f8', borderTop: 'solid #8fae1b 2px', padding: '20px 40px', maxWidth: '700px', minWidth: '375px' }}>
          <div className="mb-3 fs-5 text-body-secondary fw-medium">
          </div>
          <div className="d-flex justify-content-end">
            <button type="button" className="border-0 rounded-1 py-1 px-3 fw-bold"
              style={{ backgroundColor: '#e7e6eb', color: '#515151' }} onClick={() => navigate("/scora")}
            >CONTINUE SHOPPING</button>
          </div>
        </section>

        <section className="d-flex flex-column mx-auto mb-4 rounded-3 fs-5" style={{ border: 'solid #f6f5f8 1px', maxWidth: '780px', minWidth: '375px' }}>
          <table>
            <thead style={{ borderBottom: 'solid #f6f5f8 1px', color: '#4d4d4d', height: '35px' }}>
              <tr>
                <th scope="col" className="text-center">Product</th>
                <th scope="col" className="pe-3 pe-sm-5">Price</th>
                <th scope="col" className="pe-3 pe-sm-5">Quantity</th>
                <th scope="col" className="pe-3 pe-sm-5">Subtotal</th>
              </tr>
            </thead>
            <tbody style={{ borderBottom: 'solid #f6f5f8 1px', height: '100px' }}>
              {
                cartItems.map( (item, idx) => (
                  <tr>
                    <td className="d-flex px-5 my-auto">
                      <div className="mt-2">
                        <canvas id={"canvasItem" + idx} width="50" height="50"></canvas>
                      </div>
                      <div className="mt-3 ms-3 me-1" style={{ color: '#83a096' }}>
                        {
                          item.product == "whiteSticker" ? "Canoe Numbers - White Background/Black Letters" : "Canoe Numbers - Back Background/White Letters"
                        }
                        <br />Number {item.canoeNumber}
                      </div>
                    </td>
                    <td className="pe-3 pe-sm-5" style={{ color: '#4d4d4d' }}>${(item.quantity * getUnitPrice(item.quantity)).toFixed(2)}</td>
                    <td className="pe-3 pe-sm-5">
                      <select className="form-control rounded-0 border-secondary-subtle fs-5 text-body-secondary fw-medium"
                        style={{ width: '280px' }} value={item.quantity} onChange={(ev) => handleQntyChange(item.id, ev.target.value)} >
                        <option value="4">QTY 4 | $57.28/ea | $229.12 Total</option>
                        <option value="8">QTY 8 | $30.52/ea | $244.16 Total</option>
                        <option value="12">QTY 12 | $21.60/ea | $259.20 Total</option>
                        <option value="16">QTY 16 | $17.14/ea | $274.24 Total</option>
                        <option value="20">QTY 20 | $14.46/ea | $289.20 Total</option>
                        <option value="24">QTY 24 | $12.17/ea | $292.08 Total</option>
                        <option value="28">QTY 28 | $10.96/ea | $306.88 Total</option>
                        <option value="32">QTY 32 | $10.96/ea | $350.72 Total</option>
                      </select>
                      
                      { /*
                      <input type="number" value={item.quantity} className="text-center" onChange={(ev) => handleQntyChange(item.id, ev.target.value)}
                        min="4" max="32" style={{ width: '50px', color: '#4d4d4d' }} />
                      */ }


                      <a href="javascript:;" className="text-decoration-none fs-6 text-dark ms-1" onClick={() => removeFromCart(idx+1) }>Remove</a>
                    </td>
                    <td className="pe-3 pe-sm-5" style={{ color: '#4d4d4d' }}>${(item.quantity * getUnitPrice(item.quantity)).toFixed(2)}</td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </section>

        <section className="mx-auto" style={{ maxWidth: '700px' }}>
          <div className="ms-auto rounded-3 p-2 fs-5" style={{ border: 'solid #f6f5f8 1px', color: '#4d4d4d', width: '350px' }}>
            <div className="pb-2 d-flex" style={{ borderBottom: 'solid #f6f5f8 1px' }}>
              <div className="fw-bold" style={{ width: '120px' }}>Subtotal</div> ${money(cartSubTotal * 1)}
            </div>
            <div className="py-2 d-flex" style={{ borderBottom: 'solid #f6f5f8 1px' }}>
              <div className="fw-bold" style={{ width: '120px'}}>Shipping</div> Flat rate $14.20 to CA.
            </div>
            <div className="pt-2 d-flex">
              <div className="fw-bold" style={{ width: '120px' }}>Total</div> <span className="fw-bold">${money( cartSubTotal * 1 + 14.20)}</span>
            </div>
          </div>
          <div className="ms-auto mt-4 fs-4" style={{ width: '300px' }}>
            <button type="button" className="scoraBtn rounded-5 w-100" style={{ padding: '15px' }}
              onClick={() => navigate("/scora/checkout")}
            >PROCEED TO CHECKOUT</button>
          </div>
        </section>
      </div>
    </div>
  );
}